import React from 'react';
import { FiMapPin } from 'react-icons/fi';
import { CONTACT_INFO } from '../../utils/constants';
import { useLanguage } from '../../contexts/LanguageContext';
import { Card } from '../../components/ui/Card';

/**
 * Contact information display card
 */
export const ContactInfoCard = () => {
  const { t } = useLanguage();
  return (
    <Card className="h-full">
      <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">{t('contactInfo.title')}</h2>

      <address className="not-italic space-y-3 sm:space-y-4 mb-6 sm:mb-8">
        {CONTACT_INFO.map(({ icon: Icon, content, href, type }, index) => (
          <div key={index} className="flex items-start gap-3 sm:gap-4">
            <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Icon className="text-primary" size={18} aria-hidden="true" />
            </div>
            <div className="flex-1 min-w-0">
              <span className="text-xs sm:text-sm text-gray-500 block mb-1">
                {type === 'link' ? (href.startsWith('tel:') ? t('contactInfo.phoneLabel') : (href.startsWith('mailto:') ? t('contactInfo.emailLabel') : t('contactInfo.addressLabel'))) : t('contactInfo.addressLabel')}
              </span>
              {type === 'link' ? (
                <a
                  href={href}
                  className="text-sm sm:text-base text-gray-900 hover:text-primary transition-colors font-medium break-all touch-manipulation"
                >
                  {content}
                </a>
              ) : (
                <span className="text-sm sm:text-base text-gray-900 font-medium block">{content}</span>
              )}
            </div>
          </div>
        ))}
      </address>

      <div className="bg-gray-100 rounded-lg overflow-hidden h-[300px] w-full relative">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048.5678783478!2d29.0886!3d40.1824!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14ca3e0000000001%3A0x0!2zRHVhw6fEsW5hcsSxLCBWYXRhbiBDZC4sIFnEsWxkxLFyxLFtL0J1cnNh!5e0!3m2!1str!2str!4v1700000000000!5m2!1str!2str"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="TMR Logistics Location"
        />
      </div>
    </Card>
  );
};
